import React from "react";
import { TransferTransaction } from "model";
import { DisabledPrompt, Link, useUIState } from "bcms-react";

import { SVGAsset } from "res";
import CustomTableAccordion, { CustomTableToggle, CustomTableContent, useCustomTableAccordion } from  "components/custom-ui/CustomTableAccordion";
import { TableView, TableColumnContainer, TableItemView, TableItemTextView, FormContainer, FormRowView } from "components/shared";
import MobileScheduledTransfersTable from '../MobileScheduledTransfersTable';

import "./styles.css";

export default function ScheduledTransfersPage(props) {
    const transfers = props.transfers
    ? props.transfers
    : TransferTransaction.initAll().filter(transfer => transfer.status === "scheduled", []);

    return (
        <div className="scheduled-transfers-page">
            <div className="show-on-desktop">
                <ScheduledTransfersTable transfers={ transfers } />
            </div>

            <MobileScheduledTransfersTable transfers={ transfers } />
        </div>
    )
}

function ScheduledTransfersTable(props) {
    const transfers = props.transfers ?? [];
    const transferRows = transfers.map(transfer => {
        return <ScheduledTransfersTableItem key={ `Scheduled_Transfers_${ transfer.id }` } transfer={ transfer } />
    }, []);

    return (
        <TableView className="scheduled-transfers-table">
            <TableColumnContainer className="scheduled-transfers-header">
                <th>&nbsp;</th>
                <th className="text-left">
                    From
                    <DisabledPrompt>
                        <SVGAsset id="SortIcon" className="sort-icon clickable" />
                    </DisabledPrompt>
                </th>
                <th className="text-left">
                    To
                    <DisabledPrompt>
                        <SVGAsset id="SortIcon" className="sort-icon clickable" />
                    </DisabledPrompt>    
                </th>
                <th className="text-left">
                    Frequency
                    <DisabledPrompt>
                        <SVGAsset id="SortIcon" className="sort-icon clickable" />
                    </DisabledPrompt> 
                </th>
                <th className="text-left">
                    Next Transfer
                    <DisabledPrompt>
                        <SVGAsset id="ArrowUpIcon" className="sort-icon clickable" />
                    </DisabledPrompt> 
                </th>
                <th className="text-left">
                    Amount
                    <DisabledPrompt>
                        <SVGAsset id="SortIcon" className="sort-icon clickable" />
                    </DisabledPrompt> 
                </th>
            </TableColumnContainer>         

            {transferRows}          
        </TableView>
    )
}

function ScheduledTransfersTableItem(props) {
    const transfer = props.transfer ?? TransferTransaction.firstInstanceOf();
    const { key, config } = useUIState(`Accordion_${ transfer.id }`, { isActive: false });

    return (
        <CustomTableAccordion activeClass="open-custom-transaction-accordion" state={ config.isActive }>
            <ScheduledTransfersTableItemToggle transfer={ transfer } />
            <ScheduledTransfersTableItemContent transfer={ transfer } />
        </CustomTableAccordion>
    )
}

function ScheduledTransfersTableItemToggle(props) {
    const transfer = props.transfer ?? TransferTransaction.firstInstanceOf();
    const { state } = useCustomTableAccordion();

    return (
        <CustomTableToggle>
            <tr>
                <TableItemView className="expand-row-chevron text-center" data-point={ `Scheduled_Transfer_Arrow_${ transfer.id }` }>
                    <SVGAsset id={ state ? "DownChevronIcon" : "RightChevronIcon" } className="icon" />
                </TableItemView>

                <TableItemTextView className="text-left expanded" text={ transfer.from.nickname +" - " + transfer.from.number } />
                <TableItemTextView className="text-left expanded" text={ transfer.to.nickname +" - " + transfer.to.number } />
                <TableItemTextView className="text-left expanded" text={ transfer.frequency } />
                <TableItemTextView className="text-left expanded" text={ transfer.onDate.format("m/d/Y") }/>
                <TableItemTextView className="text-right expanded amount-column" text={ transfer.amount.format() }  />
            </tr>
        </CustomTableToggle>
    )
}

function ScheduledTransfersTableItemContent(props) {
    const transfer = props.transfer ?? TransferTransaction.firstInstanceOf();

    return (
        <CustomTableContent>
            <tr>
                <td className="scheduled-transfers-table-item" colSpan="6">
                    <div className="flex-container">
                        <p className="flex-width">TRANSFER DETAILS</p>         
                        <CustomTableToggle>
                            <SVGAsset id="CloseX" className="set-width clickable" />
                        </CustomTableToggle>          
                    </div>

                    <FormContainer>
                        <FormRowView text="Type">
                            <p>Internal Transfer</p>
                        </FormRowView>
                        
                        <FormRowView text="Deliver By">
                            <p>{ transfer.onDate.format("m/d/Y") }</p>
                        </FormRowView>
                        
                        <FormRowView text="Schedule">
                            <p>Once on { transfer.onDate.format("m/d/Y") }</p>
                        </FormRowView>
                        
                        <FormRowView text="Note">
                            <p>{ transfer.note }</p>
                        </FormRowView>
                        
                        <FormRowView className="link-container">
                            <DisabledPrompt>
                                <Link>
                                    <span data-point={ `Scheduled_Transfer_Edit_${ transfer.id }` }>Edit Transfer</span>
                                </Link>
                            </DisabledPrompt>
                        </FormRowView>
                        
                        <FormRowView className="link-container">
                            <DisabledPrompt>
                                <Link>
                                    <span data-point={ `Scheduled_Transfer_Cancel_${ transfer.id }` }>Cancel Transfer</span>
                                </Link>
                            </DisabledPrompt>
                        </FormRowView>
                    </FormContainer>
                </td>
            </tr>
        </CustomTableContent>
    )
}